import { render, staticRenderFns } from "./salesReviewAction.vue?vue&type=template&id=d38f56dc&scoped=true"
import script from "./salesReviewAction.vue?vue&type=script&lang=js"
export * from "./salesReviewAction.vue?vue&type=script&lang=js"
import style0 from "./salesReviewAction.vue?vue&type=style&index=0&id=d38f56dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38f56dc",
  null
  
)

export default component.exports